// extracted by mini-css-extract-plugin
export default {"tabsBar":"tabs_tabsBar__3jB6J","tabLabel":"tabs_tabLabel__DEg8T","active":"tabs_active__B4Wbx","slide-in-bottom":"tabs_slide-in-bottom__8OSdz"};